module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/placeholder/placeholder-02-293bdfbcb3499bc6c5e24195100daf29.jpg";